// extracted by mini-css-extract-plugin
export var chevronIcon = "_bu-2";
export var teamName = "_bu-1";
export var teamSwitcherButton = "_bu-0";